<template>
  <dialog-remainder-table ref="dialog" :title="title" :companyID="companyID" :tableConfig="config" />
</template>

<script>
import { tableConfig } from '../DialogEmailSendReminder'
export default {
  name: 'payment__dialog-remainder-table',
  components: {
    'dialog-remainder-table': () => import(/* webpackChunkName: 'DialogRemainderTable' */ '@/components/dialog-remainder-table')
  },
  props: {
    title: {
      required: true
    },
    companyID: {
      required: true
    }
  },
  computed: {
    config () {
      return tableConfig
    }
  },
  methods: {
    show () {
      this.$refs['dialog'].show()
      this.loadData()
    }
  }
}
</script>
